import { cx } from '../../lib/cx';
import styles from './countBadge.module.css';

export interface CountBadgeProps {
  /** Число. Ноль и меньше — плашки нет: «0» на колокольчике читается как событие. */
  count: number;
  /** Больше — показывается «N+». По умолчанию 99: «99+» на кнопке, а не трёхзначное число. */
  max?: number;
  className?: string;
}

/**
 * Число рядом с подписью — непрочитанное, действующие отборы (T-047).
 *
 * Ink-плашка без цвета статуса: цвет в продукте отдан сроку (DESIGN.md), а число
 * здесь — не тревога. Смысл несёт текст подписи и `aria-label` у владельца, плашка
 * для чтения с экрана скрыта, чтобы число не звучало дважды.
 */
export function CountBadge({ count, max = 99, className }: CountBadgeProps) {
  if (count <= 0) return null;
  return (
    <span className={cx(styles.badge, className)} aria-hidden="true">
      {count > max ? `${max}+` : count}
    </span>
  );
}
